import React from 'react';
import get from 'lodash.get';

// components
import { Sanitizer } from 'acq-components/lib/base-components/Sanitizer/Sanitizer';
import {
  Element,
  Type,
  Color,
  Badge,
  Typography
} from '@americanexpress/aqx-components';

export const buildBadge = offerBadge => {
  if (!offerBadge) {
    return [];
  }

  return [
    <Element key="item1">
      <Badge
        Component="h2"
        $type={Type.Secondary}
        theme={{
          marginTop: 20,
          marginLeft: 20
        }}
      >
        {offerBadge}
      </Badge>
    </Element>
  ];
};

export const buildIcon = () => ({
  directory: 'us-consumer',
  imageName: 'axp-icon-plus-filled',
  color: Color.White
});

export const buildOfferContent = offer => {
  const offers = [];

  if (offer.header && offer.description) {
    offers.push({
      title: (
        <Typography Component="h2" $size="24px" $lineHeight="32px">
          {offer.header}
        </Typography>
      ),
      description: (
        <Typography>
          <Sanitizer safelySetInnerHTML={offer.description} />
        </Typography>
      ),
      backgroundColor: 'deep-blue',
      textColor: 'white'
    });
  }

  if (Array.isArray(offer.content) && offer.content.length > 0) {
    offers.push({
      title: (
        <Typography Component="h2">
          {get(offer, 'content[0].header') || ''}
        </Typography>
      ),
      description: (
        <Typography>{get(offer, 'content[0].description') || ''}</Typography>
      ),
      backgroundColor: 'bright-blue',
      textColor: 'white',
      hasOpacity: true
    });
  }

  return offers;
};
